<template>
  <topbar
    :titulo="$t('ACADEMICO_DIARIO_CLASSE.NOTAS')"
    :subtitulo="$t('ACADEMICO_DIARIO_CLASSE.NOTAS_DESCRICAO')"
    :breadcrumbs="breadcrumbs"
  />
</template>
<script>
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';

export default {
  components: { Topbar },
  data() {
    return {
      breadcrumbs: [
        { titulo: this.$t('ACADEMICO_DIARIO_CLASSE.ACADEMICO') },
        { titulo: this.$t('ACADEMICO_DIARIO_CLASSE.DIARIO_CLASSE') },
        { titulo: this.$t('ACADEMICO_DIARIO_CLASSE.NOTAS') },
      ],
    };
  },
  methods: {},
};
</script>
